import { render, staticRenderFns } from "./activity-form-image-choice-preview.vue?vue&type=template&id=50f0571c&scoped=true&"
import script from "./activity-form-image-choice-preview.vue?vue&type=script&lang=js&"
export * from "./activity-form-image-choice-preview.vue?vue&type=script&lang=js&"
import style0 from "./activity-form-image-choice-preview.vue?vue&type=style&index=0&id=50f0571c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f0571c",
  null
  
)

component.options.__file = "activity-form-image-choice-preview.vue"
export default component.exports